import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import UsersReportsActions from "../../../components/User/UsersReportsComponents/UsersReportsActions";
import UsersReportsTable from "../../../components/User/UsersReportsComponents/UsersReportsTable";

const { getRestaurants } = appActions;

const UsersReports = () => {
  const { selectedOrganization } = useProjectState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <div>
      <PageHeader text="Справка отчет на потребители" date={true} />
      <UsersReportsActions />
      <UsersReportsTable />
    </div>
  );
};

export default UsersReports;
